import anime from 'animejs/lib/anime.es.js';
import lottie from 'lottie-web/build/player/lottie.js';

const scrollToAnimation = () => {
  let windowHeight = window.innerHeight,
    img_block_up = document?.querySelectorAll('.opportunities__img-up'),
    img_block_left = document?.querySelectorAll('.opportunities__img-left'),
    img_wave = document?.querySelectorAll('.opportunities__wave'),
    img_pay = document?.querySelectorAll('.pay__img-animation'),
    img_desc_1 = document?.querySelectorAll('.description-img-1'),
    img_desc_2 = document?.querySelectorAll('.description-img-2'),
    img_desc_3 = document?.querySelectorAll('.description-img-3'),
    img_desc_4 = document?.querySelectorAll('.project-img'),
    img_desc_5 = document?.querySelectorAll('.resume-img'),
    img_desc_6 = document?.querySelectorAll('.useful-img');

  //Скрываем элемент при загрузке страницы
  (function () {
    [...img_desc_1].map((it) => {
      it.style.opacity = '0';
    });
    [...img_desc_2].map((it) => {
      it.style.opacity = '0';
    });
    [...img_desc_3].map((it) => {
      it.style.opacity = '0';
    });
    [...img_desc_3].map((it) => {
      it.style.transform = 'translateY(250px)';
      it.style.opacity = '0';
    });
  })();

  function checkBlocksVisibility() {
    let blockPosition = document
        ?.querySelector('.opportunities')
        ?.getBoundingClientRect().top,
      blockPosition_2 = document
        ?.querySelector('.pay')
        ?.getBoundingClientRect().top,
      blockPosition_3 = document
        ?.querySelector('.description')
        ?.getBoundingClientRect().top,
      blockPosition_4 = document
        ?.querySelector('.project')
        ?.getBoundingClientRect().top,
      blockPosition_5 = document
        ?.querySelector('.resume')
        ?.getBoundingClientRect().top,
      blockPosition_6 = document
        ?.querySelector('.useful')
        ?.getBoundingClientRect().top;

    if (blockPosition <= windowHeight / 2) {
      [...img_block_up].map((it) => {
        animateBlocksUp(it,1);
      });
      [...img_block_left].map((it) => {
        animateBlocksLeft([...img_block_left]);
      });
      [...img_wave].map((it) => {
        animateWave([...img_wave]);
      });
    } else {
      [...img_block_up].map((it) => {
        it.style.transform = 'translateY(250px)';
        it.style.opacity = '0';
      });
      [...img_block_left].map((it) => {
        it.style.opacity = '0';
      });
      [...img_wave].map((it) => {
        it.style.opacity = '0';
      });
    }

    if (blockPosition_2 <= windowHeight / 2) {
      [...img_pay].map((it) => {
        animatePayBlock([...img_pay]);
      });
    } else {
      [...img_pay].map((it) => {
        it.style.transform = 'translateY(250px)';
        it.style.opacity = '0';
      });
    }

    if (blockPosition_3 <= windowHeight / 2) {
      [...img_desc_1].map((it) => {
        animateBlocksDescriptFade_1([...img_desc_1]);
      });
      [...img_desc_2].map((it) => {
        animateBlocksDescriptFade_2([...img_desc_2]);
      });
      [...img_desc_3].map((it) => {
        animateBlocksUp(it, 2800);
      });
    }

    if (blockPosition_4 <= windowHeight / 2) {
      [...img_desc_4].map((it) => {
        animateBlocksUp(it,1);
      });
    } else {
      [...img_desc_4].map((it) => {
        it.style.transform = 'translateY(40px)';
        it.style.opacity = '0';
      });
    }

    if (blockPosition_5 <= windowHeight / 2) {
      [...img_desc_5].map((it) => {
        animateBlocksResumeFade([...img_desc_5]);
      });
    } else {
      [...img_desc_5].map((it, idx) => {
        idx !== 1 ? (it.style.opacity = '0') : '';
      });
    }

    if (blockPosition_6 <= windowHeight / 2) {
      [...img_desc_6].map((it) => {
        animateUsefulBlock([...img_desc_6]);
      });
    } else {
      [...img_desc_6].map((it, idx) => {
        it.style.transform = 'translateY(100px)';
        it.style.opacity = '0';
      });
    }
  }

  //Функции анимаций
  function checkBlockVisabilityForLottie() {
    let blockPosition_3 = document
      .querySelector('.youGet')
      .getBoundingClientRect().top;

    if (blockPosition_3 <= windowHeight / 2) {
      lottieAnimation();
    }
  }

  function animateBlocksUp(it, delay) {
    anime({
      targets: it,
      opacity: 1,
      keyframes: [{ translateY: -1 }, { translateY: 0 }],
      duration: 4000,
      delay: delay !== 'undefined' ? delay : 100,
      easing: 'easeOutElastic(1, .8)',
    });
  }

  function animateBlocksDescriptFade_1(it) {
    anime({
      targets: it[5],
      opacity: 1,
      duration: 4000,
      easing: 'easeOutElastic(1, .8)',
    });

    let e = 0;
    for (let i = 4; i >= 1; i--) {
      anime({
        targets: it[i],
        opacity: 1,
        delay: (e += 200),
        duration: 4000,
        easing: 'easeOutElastic(1, .8)',
      });
    }
  }

  function animateBlocksDescriptFade_2(it) {

    let e = 800;
    for (let i = 1; i <= 10; i++) {
      anime({
        targets: it[i],
        opacity: opacityСonditions(i),
        delay: (e += 200),
        duration: 4000,
        easing: 'easeOutElastic(1, .8)',
      });
    }

    function opacityСonditions(i) {
      switch (i) {
        case 1:
          return 1;
        case 2:
          return 0.4;
        case 3:
          return 0.4;
        case 2:
          return 0.3;
        case 4:
          return 0.4;
        case 5:
          return 0.4;
        case 6:
          return 0.3;
        case 7:
          return 0.3;
        case 8:
          return 1;
        case 9:
          return 1;
        case 10:
          return 1;
      }
    }
  }
  function animateBlocksResumeFade(it) {
    let e = 0;
    for (let i = 2; i <= 6; i++) {
      anime({
        targets: it[i],
        opacity: 0.3,
        delay: (e += 100),
        duration: 4000,
        easing: 'easeOutElastic(1, .8)',
      });
    }
  }

  function animateBlocksLeft(it) {
    let e = 0;
    for (let i = 0; i <= 2; i++) {
      anime({
        targets: it[i],
        opacity: 1,
        delay: (e += 500),
        duration: 4000,
        easing: 'easeOutElastic(1, .8)',
      });
    }
  }

  function animateWave(it) {
    let e = 0;
    for (let i = 0; i <= 4; i++) {
      anime({
        targets: it[i],
        opacity: opacityСonditions(i),
        delay: (e += 200),
        duration: 4000,
        easing: 'easeOutElastic(1, .8)',
      });
    }

    function opacityСonditions(i) {
      switch (i) {
        case 0:
          return 0.5;
        case 1:
          return 0.3;
        case 2:
          return 0.3;
        case 3:
          return 0.4;
        case 4:
          return 0.4;
      }
    }
  }

  function animatePayBlock(it) {
    anime({
      targets: it[0],
      opacity: 1,
      keyframes: [{ translateY: -1 }, { translateY: 0 }],
      duration: 4000,
      easing: 'easeOutElastic(1, .8)',
    });

    let e = 0;
    for (let i = 1; i <= 2; i++) {
      anime({
        targets: it[i],
        opacity: 1,
        keyframes: [{ translateY: -1 }, { translateY: 0 }],
        delay: (e += 300),
        duration: 4000,
        easing: 'easeOutElastic(1, .8)',
      });
    }
  }

  function animateUsefulBlock(it) {
    let e = 0;
    for (let i = 1; i <= 3; i++) {
      anime({
        targets: it[i],
        opacity: 1,
        keyframes: [{ translateY: -1 }, { translateY: 0 }],
        delay: (e += 300),
        duration: 4000,
        easing: 'easeOutElastic(1, .8)',
      });
    }
  }

  function lottieAnimation() {
    lottie.loadAnimation({
      container: document.querySelector('.youGet__block-animation'),
      renderer: 'svg',
      autoplay: true,
      path: '/files/animation.json',
    });

    window.removeEventListener('scroll', checkBlockVisabilityForLottie);
  }

  // Запуска анимации при скролле до целевого блока
  window.addEventListener('scroll', checkBlocksVisibility);
  window.addEventListener('scroll', checkBlockVisabilityForLottie);
};

export default scrollToAnimation;
